import React from "react";
import {
  Card,
  CardHeader,
  Avatar,
  Checkbox,
  Typography,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { baseUrl } from "../../../services";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";

const useStyles = makeStyles((theme) => ({
  playerCardHeaderCheckBox: {
    padding: "2px",
  },
}));

const PlayerCard = ({ elem, participants, addParticipant }) => {
  const classes = useStyles();

  return (
    <Card elevation={3}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "8px 16px",
        }}
      >
        {/* Checkbox */}
        <Checkbox
          size="small"
          inputProps={{
            "aria-label": "controlled",
          }}
          checked={participants.some(
            (player) => player.playerID === elem.playerID
          )}
          className={classes.playerCardHeaderCheckBox}
          onChange={() => addParticipant(elem)}
          sx={{ marginRight: 2 }}
        />

        {/* Avatar */}
        <TitleTooltip title="View Profile" placement="bottom">
          <Avatar
            sx={{ bgcolor: "#1d428a" }}
            src={elem.headshotURL ? baseUrl(elem.headshotURL) : ""}
            alt="basketball"
          >
            {elem.playerName.split(",")[0][0]}
            {elem.playerName.split(",")[1][0]}
          </Avatar>
        </TitleTooltip>

        {/* Card Header content */}
        <Box sx={{ marginLeft: 2 }}>
          <CardHeader
            title={
              <Typography noWrap variant="subtitle2" component="p">
                {elem.playerName}
              </Typography>
            }
            subheader={
              <Typography noWrap variant="caption" component="p">
                {elem.collegeOrClub}
              </Typography>
            }
            sx={{ padding: 0 }}
          />
        </Box>
      </Box>
    </Card>
  );
};

export default PlayerCard;
